// extracted by mini-css-extract-plugin
module.exports = {"container":"cards_container__2yxBC","card":"cards_card__11EsN","infected":"cards_infected__3z_m0","recovered":"cards_recovered__1C63Y","deaths":"cards_deaths__XZmZl"};